import {
  ErrorHandlingStrategy,
  QueryOperator,
  RuleActionType,
  RuleConditionType,
  RuleTriggerType,
} from "@redotech/redo-flows-common/rules/types";
import { SchemaType } from "@redotech/redo-flows-common/schemas/schemas";
import { StepType } from "@redotech/redo-flows-core-schema-common/common";
import { DefaultRule } from "../types";

export const closeInstagramStoryMentionsRule = {
  id: "default-close-instagram-story-mentions",
  name: "Close Instagram story mentions",
  hidden: false,
  triggerType: RuleTriggerType.CONVERSATION_CREATED,

  defaultConfig: {
    defaultRuleId: "default-close-instagram-story-mentions",
    enabled: false,
    sortIndex: 12,
    configurations: {},
  },

  template: {
    name: "Close Instagram story mentions",
    enabled: true,
    schemaType: SchemaType.RULES_V3,
    steps: [
      {
        type: StepType.TRIGGER,
        id: "trigger",
        schemaType: SchemaType.RULES_V3,
        category: "Rules",
        key: RuleTriggerType.CONVERSATION_CREATED,
        nextId: "conditions",
      },
      {
        type: StepType.RULE_CONDITIONS_V3,
        id: "conditions",
        conditionGroups: {
          operator: "AND",
          conditions: [
            {
              conditionType: RuleConditionType.TICKET_CHANNEL,
              channels: ["instagram"],
              queryOperator: QueryOperator.IS,
            },
            {
              conditionType: RuleConditionType.HAS_TAG,
              tags: ["instagram_story_mention"],
              queryOperator: QueryOperator.IS,
            },
          ],
        },
        nextTrueId: "actions",
      },
      {
        type: StepType.RULE_ACTIONS_V3,
        id: "actions",
        actions: [
          { actionType: RuleActionType.SET_STATUS_V3, status: "CLOSED" },
        ],
        errorHandlingStrategy: ErrorHandlingStrategy.FAIL_FAST,
      },
    ],
  },
} as const satisfies DefaultRule<string, Record<string, never>>;
